import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43257144"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "com-upload",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  class: "search-bt",
  style: {"position":"fixed","right":"20px","top":"80px"}
}
const _hoisted_3 = {
  id: "myCanvas",
  class: "canvasDom"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.spaceName,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spaceName) = $event)),
        _ctx.searchSpace
      ],
      placeholder: "请输入搜索关键词"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zommAdd && _ctx.zommAdd(...args))),
        style: {"display":"inline-block","font-size":"30px"}
      }, [
        _createVNode(_component_van_icon, {
          name: "add-o",
          color: "#1989fa"
        })
      ]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zommDel && _ctx.zommDel(...args))),
        style: {"display":"inline-block","font-size":"30px"}
      }, [
        _createVNode(_component_van_icon, {
          name: "minus",
          color: "#1989fa"
        })
      ])
    ]),
    _createElementVNode("canvas", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaceList, (item, index) => {
        return (_openBlock(), _createElementBlock("img", {
          style: _normalizeStyle([{ left: item.deviceArr[0].left, top: item.deviceArr[0].top }, {"position":"absolute","width":"20px","height":"20px","z-index":"999","left":"20px","top":"20px"}]),
          src: _ctx.parseImgUrl('map-icon', 'device.svg'),
          alt: "",
          key: index
        }, null, 12, _hoisted_4))
      }), 128))
    ])
  ]))
}